import { mapState, mapActions } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: state => state.layoutType,
    leftSidebarType: state => state.leftSidebarType,
    layoutWidth: state => state.layoutWidth,
    topbar: state => state.topbar,
    loader: state => state.loader,
  }),
}

export const userTeamTaskComputed = {
  ...mapState('userTeamTask', {
    tab: state => state.teamTaskTab,
    activeTab: state => state.activeTab,
  }),
}
export const productComputed = {
  ...mapState('product', {
    tableData: state => state.tableData,
  }),
}

export const profileComputed = {
  ...mapState('idp', {
    userProfileData: state => state.userProfileData,
  }),
}
export const todoComputed = {
  ...mapState('todo', {
    todos: state => state.todos,
  }),
}

export const sideLinksComputed = {
  ...mapState('sideNav', {
    sideLinks: state => state.sideLinks,
    showNavItems: state => state.showNavItems,
  }),
}
export const kanbanComputed = {
  ...mapState('kanban', {
    kanbanData: state => state.kanbanData,
  }),
}
export const teamTaskComputed = {
  ...mapState('teamTask', {
    dataTable: state => state.dataTable,
    teamtaskDetail: state => state.teamtaskDetail,
    assignee: state => state.assignee,
  }),
}

export const commentsComputed = {
  ...mapState('comment', {
    comments: state => state.comments,
  }),
}

export const userHistoryComputed = {
  ...mapState('userHistory', {
    workFlowHistoryData: state => state.workFlowHistoryData,
  }),
}

export const urlQueriesComputed = {
  ...mapState('urlQueries', {
    currentPage: state => state.currentPage,
    totalCount: state => state.totalCount,
    filters: state => state.fields,
    searchQuery: state => state.searchQuery,
    pageSize: state => state.pageSize,
  }),
}

export const ListsComputed = {
  ...mapState('lists', {
    dataList: state => state.dataList,
  }),
}

export const invoiceDataComputed = {
  ...mapState('invoice', {
    isFormal: state => state.isFormal,
    factorList: state => state.factorList,
    selectedRow: state => state.selectedRow,
    customersList: state => state.customersList,
    companyList: state => state.companyList,
    invoiceList: state => state.invoiceList,
    details: state => state.details,
    productsList: state => state.productsList,
    provinceData: state => state.provinceData,
    cityData: state => state.cityData,
    invoiceDefaults: state => state.invoiceDefaults,
    updateCustomerList: state => state.updateCustomerList,
    updateProductList: state => state.updateProductList,
    agentList: state => state.agentList,
    selectedProduct: state => state.selectedProduct,
    selectedAgent: state => state.selectedAgent,
    editedInvoiceItems: state => state.editedInvoiceItems,
    deletedInvoiceItems: state => state.deletedInvoiceItems,
  }),
}

export const searchComboDataComputed = {
  ...mapState('searchCombo', {
    selectedCustomer: state => state.selectedCustomer,
    selectedCompany: state => state.selectedCompany,
  }),
}
export const userComputed = {
  ...mapState('user', {
    userDetails: state => state.userDetails,
    userProfileMenuItems: state => state.userProfileMenuItems,
    selectedCustomer: state => state.selectedCustomer,
  }),
}
export const superAdminComputed = {
  ...mapState('superAdmin', {
    columns: state => state.kanban.columns,
    availableStatuses: state => state.kanban.availableStatuses,
    tableColumns: state => state.table.columns,
    tableName: state => state.table.name,
    boardId: state => state.boardId,
    tableId: state => state.tableId,
    teamtaskName: state => state.teamtaskName,
    addable: state => state.addable,
    searchable: state => state.searchable,
    showAll: state => state.showAll,
    sortable: state => state.sortable,
    downloadable: state => state.downloadable,
    addButtonLink: state => state.addButtonLink,
    addButtonName: state => state.addButtonName,
    buttonKey: state => state.table.buttonKey,
  }),
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const productMethods = mapActions('product', ['setTableData', 'addNewStock', 'addFirstDataToTable'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const userTeamTaskMethods = mapActions('userTeamTask', ['addTeamTaskTab', 'setActiveTab', 'removeTab', 'flushTeamTasks'])

export const sideLinksMethods = mapActions('sideNav', ['addSideLinks', 'toggleDisplay'])

export const kanbanMethods = mapActions('kanban', ['setKanbanData'])

export const todoMethods = mapActions('todo', ['fetchTodos'])

export const profileMethods = mapActions('idp', ['setProfileData'])

export const teamTaskMethods = mapActions('teamTask', ['setDataTable', 'setTeamtaskDetail', 'setTeamTaskAssignee'])

export const commentMethods = mapActions('comment', ['setComments', 'addComment', 'flushComments'])

export const userHistoryMethods = mapActions('userHistory', ['setWorkFlowHistoryData'])

export const urlQueriesMethods = mapActions('urlQueries', ['setCurrentPage', 'setTotalCount', 'setFields', 'setSearchQuery', 'setPageSize', 'setCleanQueries'])

export const invoiceMethods = mapActions('invoice', [
  'setIsFormal',
  'setFactorList',
  'setSelectedRow',
  'setCustomersList',
  'setSearchedCustomersList',
  'setProvinceData',
  'setCityData',
  'receipt',
  'setSearchedCompanyList',
  'setCompanyList',
  'setInvoiceList',
  'editInvoiceList',
  'setNewDetail',
  'setNewProductList',
  'setInvoiceDefaults',
  'updateCustomerList',
  'setUpdateProductList',
  'setAgentList',
  'flushInvoiceList',
  'setSelectedProduct',
  'setSelectedAgent',
  'setEditedInvoiceItems',
  'setDeletedInvoiceItems',
  'setUpdatedInvoiceList',
  'setPaginationCustomersList',
  'setPaginationCompanyList',
  'setPaginationProductList'
])

export const searchComboMethods = mapActions('searchCombo', ['setSelectedCustomer', 'setSelectedCompany'])

export const ListsMethods = mapActions('lists', ['setDataList'])

export const userMethods = mapActions('user', ['setUserDetails', 'setUserProfileMenuItems', 'setSelectedCustomer'])

export const superAdminMethods = mapActions('superAdmin', ['setKanbanColumns', 'setAvailableStatuses', 'addKanbanColumns', 'removeKanbanColumns', 'updateAvailableStatuses', 'setTableColumns', 'setTableName', 'setInitialData'])